import React from 'react';
import { personal } from '../data';

export default function Footer() {
  return (
    <footer style={{
      maxWidth: '900px', margin: '0 auto',
      padding: '3rem 2.5rem',
      display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      borderTop: '0.5px solid rgba(100,98,92,0.15)',
      fontFamily: "'DM Mono', monospace",
      flexWrap: 'wrap', gap: '1rem',
    }}>
      <span style={{ fontSize: '11px', color: '#9b9991', letterSpacing: '0.08em' }}>
        {personal.namePlain} {personal.nameItalic} — {personal.location}
      </span>
      <span style={{ fontSize: '11px', color: '#9b9991', letterSpacing: '0.08em' }}>
        © {new Date().getFullYear()}
      </span>
    </footer>
  );
}
